import { PortalProductStrategy } from "./portal-product-strategy";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ProductKey } from "gast-common-ng2";

@Injectable()
export class OrganizationBasedProductStrategyService extends PortalProductStrategy {
  availableProducts$: Observable<ProductKey[]> = of([]);
  availableProductsAsString$: Observable<string[]> = of([]);
  selectedProduct$: Observable<ProductKey> = of("GENERAL");
  selectedProductAsString$: Observable<string> = of("");

  updateCurrentProduct(productToSet: string): void {
    // TODO 2025-04-02 Mateusz Warzyc: implement this
    console.log(productToSet);
  }
}
